import { Modal } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useResetPasswordMutation } from '../../../services';
import { toast } from 'react-toastify';
import { handleServerError } from '../../../helpers';


interface IProps {
  isModalVisible: boolean;
  handleCancel: () => void;
  openLoginModal: () => void;
  token: string | undefined;
}

const ResetPassword: FC<IProps> = (props) => {
  const { isModalVisible, handleCancel, openLoginModal, token } = props;

  const [password, setPassword] = useState<string>('');
  const [rePassword, setRePassword] = useState<string>('');
  const [searchParams, setSearchParams] = useSearchParams();

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const closeModal = () => {
    handleCancel();
    if (searchParams.has('resetToken')) {
      searchParams.delete('resetToken');
      setSearchParams(searchParams);
    }
  }

  const handleOk = () => {
    if (!password || !rePassword || !token) {
      return toast.error('Please fill out all required fields');
    }

    if (password !== rePassword) {
      return toast.error('Passwords do not match');
    }

    resetPassword({ password, token })
      .unwrap()
      .then(() => {
        toast.success(
          'Your password has been reset. Login with your new password to continue'
        );
        closeModal();
        openLoginModal();
      })
      .catch(handleServerError);
  }

  return (
    <Modal visible={isModalVisible} okButtonProps={{ disabled: isLoading }}
           okText={isLoading ? 'Resetting...' : 'Reset Password'}
           onOk={handleOk} onCancel={closeModal}>
      <header><h1>Reset Password</h1></header>
      <form>
        <div className="form-group">
          <label htmlFor="token">
            Token: <span className={"text-danger"}>*</span>
          </label>
          <input type="text" className="form-control" id="token"
                 name={'token'} value={token} required readOnly/>
        </div>
        <div className="form-group">
          <label htmlFor="password">
            Password: <span className={"text-danger"}>*</span>
          </label>
          <input type="password" className="form-control" id="password"
                 name={'password'} value={password} onChange={(e) => {
                   setPassword(e.target.value);
                 }} required/>
        </div>
        <div className="form-group">
          <label htmlFor="rePassword">
            Re-type Password: <span className={"text-danger"}>*</span>
          </label>
          <input type="password" className="form-control" id="rePassword"
                 name={'rePassword'} value={rePassword}
                 onChange={(e) => {
                   setRePassword(e.target.value);
                 }} required/>
        </div>
      </form>
      <hr/>
      <div className="center">
        <Link to="#" onClick={closeModal}>I don't remember my password</Link>
      </div>
    </Modal>
  );
}

export default ResetPassword;